// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/rfi_source_versions.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { RfiSourceVersion } from "../../datagateway/v1/rfi_source_versions_pb";
/**
 * @generated from message mono.projectdata.v1.ListRfiSourceVersionsRequest
 */ export class ListRfiSourceVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSourceVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSourceVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSourceVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSourceVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSourceVersionsRequest, "runtime", proto3);
_define_property(ListRfiSourceVersionsRequest, "typeName", "mono.projectdata.v1.ListRfiSourceVersionsRequest");
_define_property(ListRfiSourceVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiSourceVersionsResponse
 */ export class ListRfiSourceVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSourceVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSourceVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSourceVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSourceVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RfiSourceVersion versions = 1;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSourceVersionsResponse, "runtime", proto3);
_define_property(ListRfiSourceVersionsResponse, "typeName", "mono.projectdata.v1.ListRfiSourceVersionsResponse");
_define_property(ListRfiSourceVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: RfiSourceVersion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordRfiSourceVersionRequest
 */ export class RecordRfiSourceVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiSourceVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiSourceVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiSourceVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiSourceVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiSourceVersionRequest, "runtime", proto3);
_define_property(RecordRfiSourceVersionRequest, "typeName", "mono.projectdata.v1.RecordRfiSourceVersionRequest");
_define_property(RecordRfiSourceVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordRfiSourceVersionResponse
 */ export class RecordRfiSourceVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiSourceVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiSourceVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiSourceVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiSourceVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiSourceVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiSourceVersionResponse, "runtime", proto3);
_define_property(RecordRfiSourceVersionResponse, "typeName", "mono.projectdata.v1.RecordRfiSourceVersionResponse");
_define_property(RecordRfiSourceVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: RfiSourceVersion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewRfiSourceVersionRequest
 */ export class ReviewRfiSourceVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewRfiSourceVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewRfiSourceVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewRfiSourceVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewRfiSourceVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * accepted | rejected
   *
   * @generated from field: string decision = 3;
   */ _define_property(this, "decision", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewRfiSourceVersionRequest, "runtime", proto3);
_define_property(ReviewRfiSourceVersionRequest, "typeName", "mono.projectdata.v1.ReviewRfiSourceVersionRequest");
_define_property(ReviewRfiSourceVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewRfiSourceVersionResponse
 */ export class ReviewRfiSourceVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewRfiSourceVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewRfiSourceVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewRfiSourceVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewRfiSourceVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiSourceVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewRfiSourceVersionResponse, "runtime", proto3);
_define_property(ReviewRfiSourceVersionResponse, "typeName", "mono.projectdata.v1.ReviewRfiSourceVersionResponse");
_define_property(ReviewRfiSourceVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: RfiSourceVersion
        }
    ]));
